import { Button, Card, Col, Divider, Empty, Input, List, Result, Row, Skeleton, Space, Spin, Tag, notification } from "antd";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeaderAstena from "../../../Components/PageHeaderAstena";
import { BCServiceItemLine } from "../../../Interfaces/BCServiceItemLine";
import { BCServiceOrder } from "../../../Interfaces/BCServiceOrder";
import { Service } from "../../../Interfaces/Service";
import RouteLinks from "../../../Router/RouteLinks";
import { DataService } from "../../../Services/DataService";
import PlanningDetailSkeleton from "./PlanningDetailSkeleton";
import { ClockCircleOutlined, SaveOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { store } from "../../../Redux/store";
import { setSharepointSite } from "../../../Redux/Slices/appSlice";


type OrderParams = {
    orderId: string;
}

const PlanningDetail = () => {

    let navigate = useNavigate();
    let params = useParams<OrderParams>();

    const [order, setOrder] = useState<Service<BCServiceOrder>>({ status: "loading" });
    const [lines, setLines] = useState<Service<BCServiceItemLine[]>>({ status: "loading" });
    const [orderRemark, setOrderRemark] = useState<Service<string>>({ status: "loading" });

    const [technicalDescription, setTechnicalDescription] = useState<Service<string>>({ status: "loading" });
    const [newDescription, setNewDescription] = useState<string>("");
    const [hasChanges, setHasChanges] = useState<boolean>(false);
    const [changesLoading, setChangesLoading] = useState<boolean>(false);

    const [newOrderLoading, setNewOrderLoading] = useState(false);

    const [filterString, setFilterString] = useState("");

    React.useEffect(() => {
        if (params.orderId) {
            setNewOrderLoading(true);

            DataService.getServiceOrder(params.orderId).then(res => {
                setOrder(res);
                if (res.status === "loaded") {
                    store.dispatch(setSharepointSite(res.payload.sharepointSite));
                }

                DataService.getLinesForOrder(params.orderId!).then(res => {
                    setLines(res);
                }).catch(err => {
                    setLines({ status: "error", error: err })
                }).finally(() => setNewOrderLoading(false))

            }).catch(err => {
                setOrder({ status: "error", error: err })
            });
            DataService.getServiceRemark(params.orderId).then(res => {
                setOrderRemark(res);
            }).catch(err => {
                setOrderRemark({ status: "error", error: err })
            })

            DataService.getServiceTechnicalDescription(params.orderId).then(res => {
                setTechnicalDescription(res);
            }).catch(err => {
                setTechnicalDescription({ status: "error", error: err })
            })


        }
    }, [params]);

    const handleFilterChangedEvent = (inputText: string) => {
        setFilterString(inputText);
    };

    function handleDescriptionSave() {
        if (params.orderId) {
            setChangesLoading(true);
            DataService.setServiceTechnicalDescription({
                description: newDescription,
                serviceOrderNo: params.orderId
            }).then(res => {
                notification.success({
                    message: "Opslaan gelukt."
                });
                setHasChanges(false);
            }).catch(err => {
                notification.error({
                    message: "Opslaan mislukt."
                });
            }).finally(() => setChangesLoading(false))
        }
    }

    return (
        <div style={{ backgroundColor: "white" }}>
            {order.status === "error" && (
                <Card>
                    <Result
                        status="404"
                        title="404"
                        subTitle={"Order niet gevonden."}
                    />
                </Card>
            )}

            {((order.status === "loading" || lines.status === "loading" || newOrderLoading) && params.orderId && order.status != "error") && (
                <PlanningDetailSkeleton />
            )}
            {(order.status === "loaded" && lines.status === "loaded" && !newOrderLoading) && (
                <div style={{ padding: 24 }}>
                    <PageHeaderAstena
                        title={
                            <span style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "#959595" }}>{order.payload.no}</span>
                                <Title level={4} style={{ margin: 0, color: "#69ACFD" }}>
                                    {`${order.payload.description}`}
                                    {/*<Tag style={{ marginLeft: 4 }} color={order.payload.status === "Finished" ? "red" : "green"}>{order.payload.status}</Tag>*/}
                                    {lines.payload.length > 0 && (
                                        <Tag style={{ marginLeft: 4 }} color={"blue"}>{lines.payload[0].repairStatusCode}</Tag>
                                    )}
                                </Title>
                            </span>
                        }
                        extra={[
                            <Button key="1" type="primary" icon={<ClockCircleOutlined />} onClick={() => navigate(RouteLinks.timeRegistration)}>
                                Tijdsregistratie
                            </Button>
                        ]}
                    />
                    <Divider />
                    <Row>
                        <Col span={16} style={{ minHeight: "60vh", paddingRight: 8, borderRight: "1px solid #F0F0F0" }}>
                            <span style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Bijkomende info intern"}</span>
                                <div style={{ paddingLeft: 8 }}>
                                    {orderRemark.status === "loaded" && (
                                        <p style={{ overflowWrap: "break-word" }}>{orderRemark.payload}</p>
                                    )}
                                    {orderRemark.status === "loading" && (
                                        <Skeleton.Input active block style={{ height: 100, marginBottom: 8 }} />
                                    )}
                                </div>
                                <Space style={{ marginBottom: 8, justifyContent: "space-between" }}>
                                    <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Omschrijving technisch"}</span>
                                    <Button loading={changesLoading} key="1" disabled={!hasChanges} type="primary" icon={<SaveOutlined />} onClick={() => { handleDescriptionSave() }}>
                                        Opslaan
                                    </Button>
                                </Space>
                                <div style={{ paddingLeft: 8 }}>
                                    {technicalDescription.status === "loaded" && (
                                        <div>
                                            <TextArea
                                                defaultValue={technicalDescription.payload}
                                                onChange={(e) => {
                                                    setNewDescription(e.target.value);
                                                    setHasChanges(true);
                                                }}
                                                placeholder="Omschrijving technisch"
                                                autoSize={{ minRows: 3, maxRows: 10 }}

                                            />
                                        </div>
                                    )}
                                    {technicalDescription.status === "loading" && (
                                        <Skeleton.Input active block style={{ height: 100, marginBottom: 8 }} />
                                    )}
                                </div>
                                <span style={{ color: "#69ACFD", fontSize: 16, marginTop: 8 }}>{"Service artikels"}</span>
                                <Input
                                    placeholder={"Zoeken..."}
                                    onChange={(e) => handleFilterChangedEvent(e.target.value)}
                                    style={{ minWidth: 200, marginTop: 4, marginBottom: 4 }}
                                />
                                {lines.status === "loaded" && (
                                    <List
                                        grid={{ gutter: 2, column: 2 }}
                                        locale={{
                                            emptyText: <Empty description="Geen service artikels" />
                                        }}
                                        pagination={{
                                            pageSize: 8
                                        }}
                                        dataSource={
                                            lines.payload.filter(x =>
                                                x.description.toLowerCase().includes(filterString) ||
                                                x.itemNo.toLowerCase().includes(filterString) ||
                                                x.serviceItemNo.toLowerCase().includes(filterString) ||
                                                x.serialNo.toLowerCase().includes(filterString)
                                            )
                                        }
                                        renderItem={(line) => (
                                            <Card
                                                style={{ boxShadow: "rgba(149, 157, 165, 0.1) 0px 8px 24px", cursor: "pointer", margin: 2 }}
                                                bodyStyle={{ margin: 0, padding: 8 }}
                                                onClick={() => {
                                                    navigate(RouteLinks.itemDetail.replace(":lineNo", line.lineNo.toString()))
                                                }}
                                            >
                                                <span style={{ display: "flex", flexDirection: "column" }}>
                                                    <span style={{ color: "#959595", marginBottom: 4, fontSize: 10 }}>{line.serviceItemNo}</span>
                                                    <span style={{ color: "#69ACFD", fontSize: 14 }}>{line.description}</span>
                                                    <span style={{ fontSize: 12 }}>Serienummer: {line.serialNo}</span>
                                                </span>
                                            </Card>
                                        )}
                                    />
                                )}

                            </span>
                        </Col>
                        <Col span={8}>
                            <span style={{ display: "flex", flexDirection: "column", paddingLeft: 24 }}>
                                <span style={{ color: "#69ACFD", fontSize: 16 }}>{"Adres"}</span>
                                <span style={{ display: "flex", flexDirection: "row", marginTop: 2, paddingLeft: 4 }}>
                                    <span style={{ display: "flex", flexDirection: "column" }}>
                                        <span>{order.payload.shipToAddress}</span>
                                        <span>{order.payload.shipToPostCode} {order.payload.shipToCity}</span>
                                    </span>
                                </span>

                                <span style={{ color: "#69ACFD", fontSize: 16, marginTop: 8 }}>{"Contact info"}</span>
                                <span style={{ color: "#959595", paddingLeft: 4, marginTop: 2 }}>{"Klant nr."}</span>
                                <span style={{ paddingLeft: 8, marginBottom: 4 }}>{order.payload.customerNo}</span>
                                <span style={{ color: "#959595", paddingLeft: 4, marginTop: 2 }}>{"Klant naam"}</span>
                                <span style={{ paddingLeft: 8, marginBottom: 4 }}>{order.payload.customerName}</span>
                                <span style={{ color: "#959595", paddingLeft: 4, marginTop: 2 }}>{"Contact naam"}</span>
                                <span style={{ paddingLeft: 8, marginBottom: 4 }}>{order.payload.shipToContact}</span>
                                <span style={{ color: "#959595", paddingLeft: 4, marginTop: 2 }}>{"E-mail"}</span>
                                <span style={{ paddingLeft: 8, marginBottom: 4 }}>{order.payload.shipToEmail}</span>
                                <span style={{ color: "#959595", paddingLeft: 4, marginTop: 2 }}>{"Telefoon nr."}</span>
                                <span style={{ paddingLeft: 8, marginBottom: 4 }}>{order.payload.shipToPhone}</span>

                                <span style={{ color: "#69ACFD", fontSize: 16, marginTop: 8 }}>{"Algemene info"}</span>
                                <span style={{ color: "#959595", paddingLeft: 4, marginTop: 2 }}>{"Contract nr."}</span>
                                <span style={{ paddingLeft: 8 }}>{order.payload.contractNo}</span>
                            </span>
                        </Col>
                    </Row>
                </div>
            )}
        </div>

    );
};

export default PlanningDetail;